import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CccisdFieldWrapper } from 'cccisd-formik';
import useShareProjectId from 'js/hooks/useShareProjectId.js';
import { client as apollo } from 'cccisd-apollo';
import surveysQuery from './surveys.graphql';

const SurveyPicker = props => {
    const { field, form } = props;
    const [projectId] = useShareProjectId();
    const [options, setOptions] = useState(null);

    useEffect(() => {
        if (!projectId) {
            return;
        }

        (async () => {
            const result = await apollo.query({
                query: surveysQuery,
                fetchPolicy: 'network-only',
                variables: { groupId: projectId },
            });

            const list = result.data.flows.assignmentList.map(assignment => ({
                id: assignment.assignmentId,
                label: assignment.label,
                surveys: assignment.surveyList.map(survey => ({
                    id: survey.surveyId,
                    label: survey.surveyHandle ? `${survey.label} (${survey.surveyHandle})` : survey.label,
                })),
            }));
            setOptions(list);
        })();
    }, [projectId]);

    return (
        <CccisdFieldWrapper {...props} wrapperClassName="mb-0">
            {options ? (
                <select
                    className="form-select"
                    {...field}
                    {...props}
                    placeholder="Loading surveys..."
                    onChange={e => {
                        form.setFieldValue(field.name, Number(e.target.value));
                    }}
                >
                    <option value="0">-- Select survey --</option>
                    {options.map(assignment => (
                        <optgroup key={assignment.id} label={assignment.label}>
                            {assignment.surveys.map(survey => (
                                <option key={survey.id} value={survey.id}>
                                    {survey.label}
                                </option>
                            ))}
                        </optgroup>
                    ))}
                </select>
            ) : (
                <input className="form-select" placeholder="Loading surveys..." type="text" disabled />
            )}
        </CccisdFieldWrapper>
    );
};

SurveyPicker.propTypes = {
    field: PropTypes.object,
    onChange: PropTypes.func,
};

export default SurveyPicker;
